var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingLesson),expression:"loadingLesson"}],attrs:{"id":"lesson-html"}}),(_vm.lessonData.lesson_data_download_url === null)?_c('div',{staticClass:"no-lesson-placeholder"},[_c('p',[_vm._v("No Page")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }